import { Component, Input } from '@angular/core';
import { DesignBlockBaseViewComponent, WebsiteBlockAction, WebsiteMode } from '@sb/library/base';
import { WebsiteBlockTextAndMediaActionDisplayItem, WebsiteBlockTextAndMediaDisplayItem, WebsiteBlockTextAndMediaType } from '@sb/library/data-models';

@Component({
    selector: 'lib-call-to-action-design-block',
    templateUrl: './call-to-action-design-block.component.html',
    styleUrls: ['./call-to-action-design-block.component.scss']
})
export class CallToActionDesignBlockComponent extends DesignBlockBaseViewComponent {

    @Input() websiteBlockData!: WebsiteBlockTextAndMediaDisplayItem;

    ButtonClicked(): void {
        if (this.action && this.action.Link != null && this.Scope.websiteMode == WebsiteMode.Live) {
            window.open(this.action.Link, this.action.OpenInNewTab ? '_blank' : '_self')?.focus();
        } else if (this.Scope.websiteMode == WebsiteMode.Preview) {
            this.Scope.HandleBlockAction(this.websiteBlockData, WebsiteBlockAction.Edit);
        }
    }

    get action(): WebsiteBlockTextAndMediaActionDisplayItem {
        return this.websiteBlockData.Action!;
    }

    get kind(): WebsiteBlockTextAndMediaType {
        return this.websiteBlockData.TextAndMediaType;
    }

    get hasBody(): boolean {
        return this.websiteBlockData.TextAndMediaType === WebsiteBlockTextAndMediaType.CallToActionDescription
            || this.websiteBlockData.TextAndMediaType === WebsiteBlockTextAndMediaType.CallToActionAccentBackgroundDescription;
    }
}
